import { render, staticRenderFns } from "./AddPartner.vue?vue&type=template&id=36973678&scoped=true&"
import script from "./AddPartner.vue?vue&type=script&async=true&lang=js&"
export * from "./AddPartner.vue?vue&type=script&async=true&lang=js&"
import style0 from "./AddPartner.vue?vue&type=style&index=0&id=36973678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36973678",
  null
  
)

export default component.exports